var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionIconLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 7.37891L10.2266 10.8789C9.89844 11.2344 9.32422 11.2344 8.99609 10.8789C8.64062 10.5508 8.64062 9.97656 8.99609 9.64844L10.9922 7.625H5.25C4.75781 7.625 4.375 7.24219 4.375 6.75C4.375 6.28516 4.75781 5.875 5.25 5.875H10.9922L8.99609 3.87891C8.64062 3.55078 8.64062 2.97656 8.99609 2.64844C9.32422 2.29297 9.89844 2.29297 10.2266 2.64844L13.7266 6.14844C14.082 6.47656 14.082 7.05078 13.7266 7.37891ZM4.375 2.375H2.625C2.13281 2.375 1.75 2.78516 1.75 3.25V10.25C1.75 10.7422 2.13281 11.125 2.625 11.125H4.375C4.83984 11.125 5.25 11.5352 5.25 12C5.25 12.4922 4.83984 12.875 4.375 12.875H2.625C1.17578 12.875 0 11.6992 0 10.25V3.25C0 1.80078 1.17578 0.625 2.625 0.625H4.375C4.83984 0.625 5.25 1.03516 5.25 1.5C5.25 1.99219 4.83984 2.375 4.375 2.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionIconLogout);
export default __webpack_public_path__ + "static/media/section-icon-logout.be509f42c4395b1e95d5d91f3ef36090.svg";
export { ForwardRef as ReactComponent };